import { render, staticRenderFns } from "./ArticleViewPage.vue?vue&type=template&id=244a84b1&scoped=true&"
import script from "./ArticleViewPage.vue?vue&type=script&lang=js&"
export * from "./ArticleViewPage.vue?vue&type=script&lang=js&"
import style0 from "./ArticleViewPage.vue?vue&type=style&index=0&id=244a84b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a84b1",
  null
  
)

export default component.exports